import { Encoder, Utils } from '@everyboard/lib';
import { Coord } from '../../jscaip/Coord';
import { MoveCoord } from '../../jscaip/MoveCoord';
import { MoveCoordToCoord } from '../../jscaip/MoveCoordToCoord';
import { Ordinal } from '../../jscaip/Ordinal';
import { Vector } from '../../jscaip/Vector';
import { CoerceoFailure } from './CoerceoFailure';
export class CoerceoStep {
    direction;
    str;
    static LEFT = new CoerceoStep(new Vector(-2, 0), 'LEFT');
    static UP_LEFT = new CoerceoStep(Ordinal.UP_LEFT, 'UP_LEFT');
    static UP_RIGHT = new CoerceoStep(Ordinal.UP_RIGHT, 'UP_RIGHT');
    static RIGHT = new CoerceoStep(new Vector(2, 0), 'RIGHT');
    static DOWN_LEFT = new CoerceoStep(Ordinal.DOWN_LEFT, 'DOWN_LEFT');
    static DOWN_RIGHT = new CoerceoStep(Ordinal.DOWN_RIGHT, 'DOWN_RIGHT');
    static STEPS = [
        CoerceoStep.LEFT,
        CoerceoStep.UP_LEFT,
        CoerceoStep.UP_RIGHT,
        CoerceoStep.RIGHT,
        CoerceoStep.DOWN_LEFT,
        CoerceoStep.DOWN_RIGHT,
    ];
    static ofCoords(a, b) {
        const vector = a.getVectorToward(b);
        const stepIndex = CoerceoStep.STEPS.findIndex((s) => s.direction.equals(vector));
        Utils.assert(stepIndex !== -1, CoerceoFailure.INVALID_DISTANCE());
        return CoerceoStep.STEPS[stepIndex];
    }
    constructor(direction, str) {
        this.direction = direction;
        this.str = str;
    }
}
export class CoerceoRegularMove extends MoveCoordToCoord {
    static encoder = MoveCoordToCoord.getEncoder(CoerceoRegularMove.of);
    static of(start, end) {
        const step = CoerceoStep.ofCoords(start, end);
        const move = CoerceoRegularMove.ofMovement(start, step);
        return move;
    }
    static ofMovement(start, step) {
        const landingCoord = new Coord(start.x + step.direction.x, start.y + step.direction.y);
        return new CoerceoRegularMove(start, landingCoord);
    }
    constructor(start, end) {
        super(start, end);
    }
    toString() {
        return 'CoerceoRegularMove(' + this.getStart().toString() + ' > ' + this.getEnd().toString() + ')';
    }
    equals(other) {
        if (CoerceoMove.isTileExchange(other)) {
            return false;
        }
        else {
            return super.equals(other);
        }
    }
}
export class CoerceoTileExchangeMove extends MoveCoord {
    static encoder = MoveCoord.getEncoder(CoerceoTileExchangeMove.of);
    static of(capture) {
        return new CoerceoTileExchangeMove(capture);
    }
    constructor(capture) {
        super(capture.x, capture.y);
    }
    toString() {
        return 'CoerceoTileExchangeMove(' + this.coord.x + ', ' + this.coord.y + ')';
    }
    equals(other) {
        if (CoerceoMove.isTileExchange(other)) {
            return other.coord.equals(this.coord);
        }
        else {
            return false;
        }
    }
}
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var CoerceoMove;
(function (CoerceoMove) {
    function isNormalMove(move) {
        return move instanceof CoerceoRegularMove;
    }
    CoerceoMove.isNormalMove = isNormalMove;
    function isTileExchange(move) {
        return move instanceof CoerceoTileExchangeMove;
    }
    CoerceoMove.isTileExchange = isTileExchange;
    CoerceoMove.encoder = Encoder.disjunction([CoerceoMove.isNormalMove, CoerceoMove.isTileExchange], [CoerceoRegularMove.encoder, CoerceoTileExchangeMove.encoder]);
})(CoerceoMove || (CoerceoMove = {}));
